document.addEventListener('DOMContentLoaded', () => {
  const searchInput = document.getElementById('homepageSearch');
  const cardsGrid = document.getElementById('cardsGrid');
  const noResults = document.getElementById('noResults');

  if (!cardsGrid) return;

  const brochureRoot = document.getElementById('brochureListRoot');
  const isBrochurePage = Boolean(brochureRoot);

  if (!isBrochurePage && !searchInput) return;

  const cards = Array.from(cardsGrid.querySelectorAll('.card-item'));
  const perPage = Number(brochureRoot?.dataset.perPage || 12);
  const loadMoreBtn = document.getElementById('loadMoreBtn');
  const loadMoreContainer = document.getElementById('loadMoreContainer');
  let visibleLimit = perPage;

  const getCheckedValues = (filterId) => {
    const root = document.querySelector(`[data-filter-id="${filterId}"]`);
    if (!root) return [];
    return Array.from(root.querySelectorAll('.multi-select-option:checked')).map(
      (input) => input.value
    );
  };

  const performSearch = ({ resetLimit = false } = {}) => {
    if (resetLimit) visibleLimit = perPage;

    const searchTerm = searchInput ? searchInput.value.toLowerCase().trim() : '';
    const statuses = isBrochurePage ? getCheckedValues('brochureStatus') : [];
    const authors = isBrochurePage ? getCheckedValues('brochureAuthor') : [];
    const units = isBrochurePage ? getCheckedValues('brochureUnit') : [];
    let matchCount = 0;
    let shownCount = 0;

    cards.forEach((card) => {
      const title = card.getAttribute('data-title') || '';
      const description = card.getAttribute('data-description') || '';
      const status = card.getAttribute('data-status') || '';
      const author = card.getAttribute('data-author') || '';
      const unit = card.getAttribute('data-unit') || '';

      const matches =
        (searchTerm === '' ||
          title.includes(searchTerm) ||
          description.includes(searchTerm)) &&
        (statuses.length === 0 || statuses.includes(status)) &&
        (authors.length === 0 || authors.includes(author)) &&
        (units.length === 0 || units.includes(unit));

      if (!matches) {
        card.style.display = 'none';
        return;
      }

      matchCount += 1;
      if (!isBrochurePage || shownCount < visibleLimit) {
        card.style.display = '';
        shownCount += 1;
      } else {
        card.style.display = 'none';
      }
    });

    if (
      matchCount === 0 &&
      (searchTerm !== '' || statuses.length > 0 || authors.length > 0 || units.length > 0)
    ) {
      cardsGrid.style.display = 'none';
      noResults?.classList.remove('hidden');
    } else {
      cardsGrid.style.display = '';
      noResults?.classList.add('hidden');
    }

    if (isBrochurePage && loadMoreContainer) {
      loadMoreContainer.classList.toggle('hidden', matchCount <= visibleLimit);
    }
  };

  if (isBrochurePage) {
    window.triggerFilter = () => performSearch({ resetLimit: true });

    loadMoreBtn?.addEventListener('click', () => {
      visibleLimit += perPage;
      performSearch();
    });
  }

  if (searchInput) {
    searchInput.addEventListener('input', () => performSearch({ resetLimit: true }));
    searchInput.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        performSearch({ resetLimit: true });
      }
    });

    document.getElementById('homepageSearchBtn')?.addEventListener('click', (e) => {
      e.preventDefault();
      performSearch({ resetLimit: true });
    });
  }

  performSearch({ resetLimit: true });
});
